window.Mask = function() {
    var el = this;
    
    el.data = {};
    
    el.show = function () {
        var templateData = {
            masks: []
        };
        
        for (var i in el.data) {
            templateData.masks.push(el.data[i]);
        }
        
        el.dialog.show('masks', templateData);
    };
    
    el.set = function(companyId, name) {
        el.update(companyId, name, el.selectWorkareaId, el.selectId);
        el.workarea.render();
        el.preview.update();
        el.history.add();
        el.dialog.hide('masks');
    };
    
    
    el.update = function(companyId, name, selectWorkareaId, selectId) {
        if (name === '') {
            return false;
        }
        
        var reversal = el._parent.workData.workareas[selectWorkareaId].format;

        if (name !== undefined) {
            reversal.images[selectId].mask = name;
            reversal.images[selectId].company_id = companyId;
            reversal.cells[selectId].border_opacity = 0;
        } else if (reversal.images.hasOwnProperty(el.selectId)) {
            delete(reversal.images[selectId].mask);
            delete(reversal.images[selectId].company_id);
        }
    };
    
    $(document).on('click', '.js-mask-reset', function() {el.set();});
    $(document).on('click', '.js-mask-set', function() {
        el.set($(this).attr('data-company'), $(this).attr('data-name'));
    });
};